// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioButton_root__-5e6y","input":"RadioButton_input__-ECWf","ellipse":"RadioButton_ellipse__1Jhrs","text":"RadioButton_text__1uDiO"};